var _path, _rect, _path2, _path3, _path4, _ellipse, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlassWithShellLessEggInVinegar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 90,
    viewBox: "0 0 63 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 0C0.671573 0 0 0.671573 0 1.5C0 2.32843 0.671575 3 1.5 3H1.60938C1.8047 3 2 4 2 4V86C2 88.2091 3.79086 90 6 90H57C59.2091 90 61 88.2091 61 86V4C61 4 61.1953 3 61.3906 3H61.5C62.3284 3 63 2.32843 63 1.5C63 0.671573 62.3284 0 61.5 0H61H2H1.5Z",
    fill: "#CDE2ED"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 25,
    height: 2,
    rx: 1,
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14267 45L54.8695 44.9631C57.148 44.9631 59 43.0959 59 40.7988V19.5803C39.3954 18.8923 29.0321 16 4 16L4 40.8233C4 43.1328 5.85202 45 8.14267 45Z",
    fill: "#33BEF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22.2V83.7989C4 86.1287 5.85038 88.0123 8.139 87.9999L54.8245 87.9628C57.1009 87.9628 59 85.9974 59 83.68V16.44C59 16.0187 58.9757 15.4213 59 15C39.7902 15.1859 30.7949 22.2 4 22.2Z",
    fill: "#66CEF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.712 63.5333C44.0092 51.5333 36.2446 45 31 45C25.7554 45 17.9908 51.5333 16.288 63.5333C14.6533 75.5333 20.0341 85 31 85C41.9659 85 47.3467 75.5333 45.712 63.5333Z",
    fill: "url(#paint0_radial_10258_11795)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.0873,
    cy: 75.1711,
    rx: 7.58721,
    ry: 7.4359,
    fill: "url(#paint1_radial_10258_11795)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 8,
    width: 12,
    height: 78,
    rx: 3,
    fill: "white",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10258_11795",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31 65) rotate(90) scale(20 15)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F2DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3DD98"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10258_11795",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.0873 75.1711) rotate(90) scale(7.4359 7.58721)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#F69517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDE7A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassWithShellLessEggInVinegar);
export default __webpack_public_path__ + "static/media/glass_with_shell_less_egg_in_vinegar.b5f9a4e9118d4800a61b543a678f43e8.svg";
export { ForwardRef as ReactComponent };